import apiClient from './config';

export default {
  // Récupérer tous les employés
  getAllStaff(params = {}) {
    return apiClient.get('/firm/admins', { params });
  },

  // Récupérer un employé par ID
  getStaffById(id) {
    return apiClient.get(`/firm/staff/${id}`);
  },

  // Créer un nouvel employé
  createStaff(data) {
    return apiClient.post('/firm/admins', data);
  },

  // Mettre à jour un employé
  updateStaff(id, data) {
    return apiClient.put(`/firm/staff/${id}`, data);
  },

  // Supprimer un employé
  deleteStaff(id) {
    return apiClient.delete(`/firm/staff/${id}`);
  },

  // Changer le statut d'un employé (actif/inactif)
  updateStaffStatus(id, status) {
    return apiClient.patch(`/firm/staff/${id}/status`, { status });
  },

  // Récupérer le planning d'un employé
  getStaffSchedule(id, params = {}) {
    return apiClient.get(`/firm/staff/${id}/schedule`, { params });
  },

  // Valider les données d'un employé
  validateStaff(data) {
    return apiClient.post('/firm/staff/validate', data);
  },

  // Récupérer les statistiques d'un employé
  getStaffStats(id) {
    return apiClient.get(`/firm/staff/${id}/stats`);
  },
};
